export enum MENUS {
  SIGN = 'signMenu',
  FEEDBACK = 'feedbackMenu',
  REQUEST = 'requestMenu',
  PAYMENT = 'paymentMenu',
  PAYMENT_STATUS = 'paymentStatusMenu',
  REFUSE = 'refuseMenu',
}

export const isMenu = (menu: unknown): menu is MENUS => {
  if (menu && Object.values(MENUS).find((value) => menu === value)) {
    return true;
  }

  return false;
};
